import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuOpen(false);
  };

  const handleCareersClick = () => {
    navigate('/careers');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo" onClick={handleLogoClick}>
          <div className="logo-icon">
            <img src="/logo_white.png" alt="DT Consultancy Logo" />
          </div>
          <div className="logo-text">
            <span className="logo-main">DT Consultancy</span>
            <span className="logo-tagline">AN IDEA PER LIFE</span>
          </div>
        </div>
        
        <nav className={`nav ${menuOpen ? 'active' : ''}`}>
          <a onClick={() => scrollToSection('hero')} className="nav-link">
            <span>Home</span>
          </a>
          <a onClick={() => scrollToSection('services')} className="nav-link">
            <span>Services</span>
          </a>
          <a onClick={() => scrollToSection('solutions')} className="nav-link">
            <span>Solutions</span>
          </a>
          <a onClick={() => scrollToSection('about')} className="nav-link">
            <span>About</span>
          </a>
          <a onClick={() => scrollToSection('testimonials')} className="nav-link">
            <span>Testimonials</span>
          </a>
          <a onClick={handleCareersClick} className="nav-link">
            <span>Careers</span>
          </a>
          <button 
            className="btn-contact" 
            onClick={() => scrollToSection('contact')}
          >
            Contact Us
          </button>
        </nav>

        <button 
          className={`menu-toggle ${menuOpen ? 'active' : ''}`} 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
